function deepCopy(from, to) {
  /* eslint no-prototype-builtins: 0 */
  Object.keys(from).forEach(m => {
    if (typeof from[m] !== 'object') {
      if (from.hasOwnProperty('length')) {
        to.splice(m, 1, from[m])
      } else {
        to[m] = from[m]
      }
    } else {
      if (!to[m] && from[m].hasOwnProperty('length')) {
        if (from.hasOwnProperty('length')) {
          to.splice(m, 1, [])
        } else {
          to[m] = []
        }
      } else if (!to[m]) {
        if (from.hasOwnProperty('length')) {
          to.splice(m, 1, {})
        } else {
          to[m] = {}
        }
      }
      deepCopy(from[m], to[m])
    }
  })
}

export default {
  AjaxRootPath: '/api',
  Storage: 'payp-',
  deepCopy,
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js